namespace $.$$ {
	export const $eve_selection_attr = "[eve_selected]"
}
